module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Expander",
    class: _vm.elClass,
    on: {
      "click": _vm.click
    }
  }, [_c('icon', {
    staticClass: "Expander-icon",
    attrs: {
      "name": "plus",
      "width": "13.95px",
      "height": "13.95px"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f758701"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Expander.vue
// module id = 806
// module chunks = 1